import { apiService } from '@/services/APIService';
import { rHandler } from '@/plugins/RHandler';
import { DEFAULT_PARAMS } from '@/utils/objectsRHandler';
import EventDeletionProcess from '../list/event-deletion-process';

const API_PATH = 'event-deletion-processes';

export const deletionProcesses = (type) => ({
  active({ args = [] } = DEFAULT_PARAMS) {
    const [eventId] = args;
    return rHandler(
      apiService.get(API_PATH, { 'search[event_id]': eventId, 'search[type]': type, 'search[active]': 1 }),
      (response) => ({ response, items: response.data.data.map((item) => new EventDeletionProcess(item)) }),
      (error) => ({ error }),
    );
  },
  status({ args = [] } = DEFAULT_PARAMS) {
    const [id] = args;
    return rHandler(
      apiService.get(`${API_PATH}/${id}`),
      (response) => ({ response, item: new EventDeletionProcess(response.data.data) }),
      (error) => ({ error }),
    );
  },
  retry({ args = [] } = DEFAULT_PARAMS) {
    const [id] = args;
    return rHandler(
      apiService.post(`${API_PATH}/${id}/retry`),
      (response) => ({ response, item: new EventDeletionProcess(response.data.data) }),
      (error) => ({ error }),
    );
  },
});
